import { format } from 'date-fns'

export default {
  domain (newDomain, oldDomain) {
    this.onDomainChange(newDomain, oldDomain)
  },
  dateEnd (value) {
    this.handleDateBoundaryChange('dateEnd', value)
  },
  dateStart (value) {
    this.handleDateBoundaryChange('dateStart', value)
  },
  dateRange (value) {
    if (!Array.isArray(value) || value.length !== 2) {
      return
    }
    const [start, end] = value
    if (start) {
      const startStr = start instanceof Date ? format(start, 'yyyy-MM-dd') : start
      if (this.dateStart !== startStr) {
        this.dateStart = startStr
      }
    }
    if (end) {
      const endStr = end instanceof Date ? format(end, 'yyyy-MM-dd') : end
      if (this.dateEnd !== endStr) {
        this.dateEnd = endStr
      }
    }
  },
  isLayoutEditMode (value) {
    if (!value) {
      this.draggingColumn = null
      this.draggingId = null
      this.saveCardOrder('right')
    }
  },
  keywordAlerts (alerts) {
    if (!this.selectedAlertKeyword) {
      return
    }
    if (!alerts || !alerts.length) {
      this.selectedAlertKeyword = null
      return
    }
    const found = alerts.some(alert => alert.word === this.selectedAlertKeyword.word)
    if (!found) {
      this.selectedAlertKeyword = null
    }
  }
}
